module.exports = __webpack_public_path__ + "static/media/PC_Workshop_GOVERNANCA_CORPORATIVA_E_TI.42e2f1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/governanca/PC_Workshop_GOVERNANCA_CORPORATIVA_E_TI.png
// module id = 95
// module chunks = 0